import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// Custom validator to check if the input contains only spaces
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value =
      typeof control.value === 'object'
        ? control.value?.target?.value
        : control.value;
    const isOnlyWhitespace =
      typeof value === 'string' &&
      value.length > 0 &&
      value.trim().length === 0;
    return isOnlyWhitespace ? { noWhiteSpaceError: true } : null;
  };
}
